<template>

    <div class="w-full">
        
        <div class="w-full pb-5 max-w-[59rem] rounded-[5px] mx-auto grid md:grid-cols-2 gap-10 ">
            <div class="w-full  rounded-[5px] border border-gray-300 shadow-lg shadow-gray-400 p-5">
                <h2 class="font-medium text-lg">Free</h2>
                <p class="text-gray-500 text-sm mt-2">For a daily productivity kick</p>
                <div class="w-full mt-3 flex justify-between items-center">
                    <div class="flex items-center">
                        <p class="text-4xl font-bold mr-2">$0</p>
                        <p class="text-xs text-gray-400 flex flex-col">
                            <span>per user</span>
                            <span>per month</span>
                        </p>
                    </div>
                    <img src="/images/website/free_plan.webp" class="h-16">
                </div>
                
                <div class="w-full mt-3">
                    <button class="w-full font-medium bg-blue-600 text-white rounded-[5px] py-2 px-5 text-center">Start for free</button>                
                </div>
                <div class="w-full mt-3">
                    <p class="text-gray-500 text-sm">credits/month</p>
                    <div class="w-full mt-3">
                        <div class="text-lg flex items-center">
                            <span class="flex justify-center items-center w-7 h-7 rounded-full bg-pink-400 mr-3"><svg class="w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"/></svg></span>
                            <span class="font-semibold mr-1">20</span>
                            <span class="text-gray-600">email finder</span>
                        </div>  
                        <div class="text-lg flex items-center mt-2">
                            <span class="flex justify-center items-center w-7 h-7 rounded-full bg-orange-400 mr-3"><svg class="w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"/></svg></span>
                            <span class="font-semibold mr-1">5</span>
                            <span class="text-gray-600">mobile phone finder</span>
                        </div>  
                        <div class="text-lg flex items-center mt-2">
                            <span class="flex justify-center items-center w-7 h-7 rounded-full bg-lime-400 mr-3"><svg class="w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"/></svg></span>
                            <span class="font-semibold mr-1">Unlimited</span>
                            <span class="text-gray-600">email validation</span>
                        </div>                
                    </div>
                </div>
                <div class="border-t border-gray-300 text-[15px] space-y-4 mt-5 w-full py-5">
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>B2B contact details finder</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>Message templates (limited)</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>2,000 Actions minutes/month</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>B2B contact details finder</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>Message templates (limited)</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>2,000 Actions minutes/month</span>
                    </div>
                </div>
            </div>

            <div class="w-full  rounded-[5px] border border-gray-300 shadow-lg shadow-gray-400 p-5">
                <h2 class="font-medium text-lg">Featured</h2>
                <p class="text-gray-500 text-sm mt-2">For a daily productivity kick</p>
                <div class="w-full mt-3 flex justify-between items-center">
                    <div class="flex items-center">
                        <p class="text-4xl font-bold mr-2">$15</p>
                        <p class="text-xs text-gray-400 flex flex-col">
                            <span>per user</span>
                            <span>per month</span>
                        </p>
                    </div>
                    <img src="/images/website/free_plan.webp" class="h-16">
                </div>
                
                <div class="w-full mt-3">
                    <button class="w-full font-medium bg-blue-600 text-white rounded-[5px] py-2 px-5 text-center">Start for free</button>                
                </div>
                <div class="w-full mt-3">
                    <p class="text-gray-500 text-sm">credits/month</p>
                    <div class="w-full mt-3">
                        <div class="text-lg flex items-center">
                            <span class="flex justify-center items-center w-7 h-7 rounded-full bg-pink-400 mr-3"><svg class="w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"/></svg></span>
                            <span class="font-semibold mr-1">20</span>
                            <span class="text-gray-600">email finder</span>
                        </div>  
                        <div class="text-lg flex items-center mt-2">
                            <span class="flex justify-center items-center w-7 h-7 rounded-full bg-orange-400 mr-3"><svg class="w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"/></svg></span>
                            <span class="font-semibold mr-1">5</span>
                            <span class="text-gray-600">mobile phone finder</span>
                        </div>  
                        <div class="text-lg flex items-center mt-2">
                            <span class="flex justify-center items-center w-7 h-7 rounded-full bg-lime-400 mr-3"><svg class="w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"/></svg></span>
                            <span class="font-semibold mr-1">Unlimited</span>
                            <span class="text-gray-600">email validation</span>
                        </div>                
                    </div>
                </div>
                <div class="border-t border-gray-300 text-[15px] space-y-4 mt-5 w-full py-5">
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>B2B contact details finder</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>Message templates (limited)</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>2,000 Actions minutes/month</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>B2B contact details finder</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>Message templates (limited)</span>
                    </div>
                    <div class="flex items-center">
                        <span>
                            <svg  class="w-5 h-5 fill-green-800 mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>                   
                        </span>    
                        <span>2,000 Actions minutes/month</span>
                    </div>
                </div>
            </div>


        </div>
    </div>

  
</template>

<script>
import Constants from "controllers/vue_components/mixins/constants"
import RequestMixin from "controllers/vue_components/mixins/request"

export default {
    name: 'Individuals',
    props: [],
    mixins: [Constants, RequestMixin],
    data() {
        return {
        };
    },
    methods: {
        
    },

    computed: {},
    created() {
    }
};
</script>
